module.exports = __webpack_public_path__ + "static/media/splash-logo.188019ab.svg";